
export const SIGNED_IN = 'SIGNED_IN';
export const UPDATE_LIST = 'UPDATE_LIST';
export const UPDATE_FILE_INFO = 'UPDATE_FILE_INFO';

export const UPDATE_ERR = 'UPDATE_ERR';
